// Define a constant for milliseconds
const TEN_SECONDS_MS = 10000;

// Export timeout durations for API calls
export const ApiTimeouts = {
  DEFAULT_TIMEOUT: TEN_SECONDS_MS,
  GET_LISTING: TEN_SECONDS_MS, // Timeout for the "Get Listing" API in milliseconds
};
